<template>
  <div class="account-investigation-onboarding">
    <progress-header
      :top-image-path="'header-bank-square-top.svg'"
      :bottom-image-path="'header-bank-square-bottom.svg'"
      :header-text="'מצוין! חשבון הבנק שלך חובר בהצלחה לriseup'"
      :color-variant="'blue'"
    />
    <div class="page-content">
      <div class="description">
        <div class="title">חיבור חשבונות בנק</div>
        <div class="subtitle">אילו חשבונות בנק לכלול בתזרים החודשי שלך?</div>
        <info-tool-tip
          class="tool-tip-wrapper"
          :text="'אילו חשבונות בנק לכלול בתזרים החודשי ואילו עדיף שלא? '"
          :popup-text="'אפשר לקרוא כאן.'"
          :event-name="'AccountSelectionTooltipClicked'"
          :popup-component="accountInvestigationHelpPopup"/>
      </div>
      <separator/>
      <div class="accounts-container">
        <div class="accounts-section-content" v-for="question in accountQuestions" :key="question.account">
          <account-card
            class="account-card-wrapper"
            :source-name="question.source"
            :bank-display-name="bankDisplayName(question)"
            :account-number="question.account"
            :is-included="question.isIncluded"
            :toggle-included="() => toggleAccountIsIncluded(question.account)"/>
        </div>
        <separator/>
        <add-credentials-card class="new-account-wrapper" :title="'אני רוצה לחבר חשבון בנק נוסף'" :add-new-credentials="goToBankSelection"/>
      </div>
      <div class="button-container">
        <riseup-button class="done-btn"
                       :loading="isLoading"
                       :action="doneAnswering"
                       :disabled="!isLoading && noIncludedAccounts"
                       :title="'אפשר להמשיך'"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import BaseUI from 'base-ui';
import ProgressHeader from '../../../../../../base-components/onboarding/ProgressHeader.vue';
import InfoToolTip from '../../../../../../base-components/onboarding/InfoToolTip.vue';
import AccountCard from '../../../../../../base-components/onboarding/AccountCard.vue';
import AddCredentialsCard from '../../../../../../base-components/onboarding/AddCredentialsCard.vue';
import consts from '../../../../../../constants/onboarding-state';
import PromotionPopup from '../../../../../../base-components/onboarding/discount/PromotionPopup.vue';
import ModalBus from '../../../../../../event-bus/modal-bus';
import Segment from '../../../../../../Segment';
import AccountInvestigationHelpPopup
  from '../../../../../../base-components/onboarding/help-popups/AccountInvestigationHelpPopup.vue';
import sourcesFields from '../../../../../../constants/sourcesFields';

export default {
  name: 'AccountInvestigation',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    Separator: BaseUI.Separator,
    ProgressHeader,
    InfoToolTip,
    AccountCard,
    AddCredentialsCard,
    PromotionPopup,
  },
  async created() {
    await this.fetchAccounts();
    Segment.trackUserGot('AccountSelectionEntered', { numberOfAccounts: this.accountQuestions.length });
  },
  computed: {
    ...mapState('accountInvestigationOnboarding', ['accountQuestions', 'showDiscountPromotion']),
    ...mapGetters('accountInvestigationOnboarding', ['noIncludedAccounts']),
    ...mapState('onboardingState', ['isLoading']),
    accountInvestigationHelpPopup() {
      return AccountInvestigationHelpPopup;
    },
  },
  methods: {
    ...mapActions('accountInvestigationOnboarding', ['fetchAccounts', 'saveAccountInputs']),
    ...mapMutations('accountInvestigationOnboarding', ['toggleAccountIsIncluded']),
    ...mapMutations('onboardingState', ['setLoadingState', 'setPageName']),
    async doneAnswering() {
      const totalNumberOfAccounts = this.accountQuestions.length;
      const selectedNumberOfAccounts = this.accountQuestions.filter(accountQuestion => accountQuestion.isIncluded).length;
      Segment.trackUserInteraction('AccountSelectionNextClicked', { totalNumberOfAccounts, selectedNumberOfAccounts });
      this.setLoadingState(true);
      await this.saveAccountInputs();
    },
    async goToBankSelection() {
      Segment.trackUserInteraction('AccountSelectionAddNewClicked');
      await this.setPageName(consts.ONBOARDING_PAGE.BANK_SELECTION);
    },
    bankDisplayName(question) {
      return sourcesFields.sourceDisplayName(question.source);
    },
  },
  watch: {
    async showDiscountPromotion(newValue, oldValue) {
      if (newValue) {
        ModalBus.$emit('open', {
          component: PromotionPopup,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';

.account-investigation-onboarding {
  @include white-page-frame;
  height: 100%;

  .page-content {
    margin-top: 40px;
    height: 100%;
    width: 100%;

    .description {
      @include responsive-padding;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: $riseup_v2_blue;
        margin-bottom: 20px;
      }

      .subtitle {
        font-size: 18px;
        color: $riseup_black;
        margin-bottom: 20px;
        line-height: 1.44;
      }

      .tool-tip-wrapper {
        margin-bottom: 40px;
      }

    }

    .accounts-container {
      width: 100%;
      background-color: $riseup_v2_light_grey;
      @include responsive-padding;
      padding-top: 25px;
      padding-bottom: 25px;

      .accounts-section-content {
        margin-bottom: 30px;

        .account-card-wrapper {
          margin-bottom: 16px;
        }
      }

      .new-account-wrapper {
        margin-top: 30px;
      }
    }

    .button-container {
      @include responsive-padding-top-bottom;
      @include responsive-padding;

      .done-btn {
        width: 100%;
        white-space: nowrap;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard2/steps/account-investigation/AccountInvestigationOnboarding.vue